import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../../../Pagination';
import LoadMoreToursButton from '../LoadMoreToursButton';
import { setTourTripSearchParam, tourSearchRequest } from '../../../../store/slices/tripSearch';

const TourPagination = ({ tripId, className, doShowLoadMore }) => {
  const dispatch = useDispatch();
  const isTripSearch = !tripId;
  const searchObj = useSelector((store) => store.tripSearch.searchObj.tour);
  const response = useSelector((store) =>
    isTripSearch
      ? store.tripSearch.searchResult
      : (store.tour.tourSearches[tripId] || {}).responses,
  );

  const page = searchObj?.page || 1;
  const totalCount = response?.total;
  const pageSize = response?.pageSize;

  const goToPage = (nextPage) => {
    if (nextPage === page) {
      return;
    }
    dispatch(setTourTripSearchParam({ page: nextPage }));
    dispatch(tourSearchRequest({ isTripSearch, tripId }));
  };

  const handleNextPageClick = () => {
    if (!pageSize || !totalCount || page * pageSize >= totalCount) {
      return;
    }
    goToPage(page + 1);
  };

  const handlePrevPageClick = () => goToPage(page > 1 ? page - 1 : page);

  return (
    <>
      {doShowLoadMore && <LoadMoreToursButton tripId={tripId} className="mt-2" />}
      <div className={className}>
        <Pagination
          page={page}
          pageSize={pageSize}
          totalCount={totalCount}
          onPrevPageClick={handlePrevPageClick}
          onNextPageClick={handleNextPageClick}
          resultsLabel="tours"
        />
      </div>
    </>
  );
};

TourPagination.propTypes = {
  tripId: PropTypes.string,
  className: PropTypes.string,
  doShowLoadMore: PropTypes.bool,
};

TourPagination.defaultProps = {
  tripId: undefined,
  className: undefined,
  doShowLoadMore: false,
};

export default TourPagination;
